import { render, staticRenderFns } from "./DebtVisitCard.vue?vue&type=template&id=8be6b80c&scoped=true"
import script from "./DebtVisitCard.vue?vue&type=script&lang=js"
export * from "./DebtVisitCard.vue?vue&type=script&lang=js"
import style0 from "./DebtVisitCard.vue?vue&type=style&index=0&id=8be6b80c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8be6b80c",
  null
  
)

export default component.exports